// This file is auto-generated by scripts/gen-build-info.mjs — do not edit.
export const APP_VERSION = '1.4.0-24';
